export default __webpack_public_path__ + "7506b15978638d3c03bbc60b09a33f18.svg";